<template>
  <div
    v-if="currentDaySchedule"
    class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-6"
  >
    <slot
      :not-available="notAvailable"
      :schedule="currentDaySchedule"
    >
      <span class="cf-icon far fa-clock" />

      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
        {{ currentDaySchedule }}
      </p>
    </slot>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';
  import moment from 'moment-timezone';

  import timeOfDay from '@/filters/time-of-day';


  export default {
    name: 'CfCurrentDayMenuSchedule',

    props: {
      schedule: {
        type: Array,
        default() {
          return [];
        }
      }
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),

      currentDaySchedule() {
        if (this.schedule.length === 0) {
          return null;
        }

        const dayparts = [];
        const today = this.selectedLocation.storeId ? moment().tz(this.selectedLocation.timeZone) : moment();
        const dayOfWeek = today.format('dddd');
        const schedules = this.schedule.filter(s => s.day === dayOfWeek);

        schedules.forEach((schedule) => {
          /*
            NOTE:
            If both startTime and endTime are 00:00:00, that means the whole day is NOT valid.
            If startTime is 00:00:00 and endTime is 23:59:59, that means the whole day is valid.
          */

          if (schedule.startTime === '00:00:00' && schedule.endTime === '23:59:59') {
            return;
          }

          if (schedule.startTime === '00:00:00' && schedule.endTime === '00:00:00') {
            dayparts.push('Not Available Today');
            return;
          }

          const startTimeDisplay = timeOfDay(schedule.startTime);
          const endTimeDisplay = timeOfDay(schedule.endTime);

          dayparts.push(`${startTimeDisplay}–${endTimeDisplay}`);
        });

        if (dayparts.length > 0) {
          return dayparts.join(', ');
        }


        return null;
      },

      notAvailable() {
        return this.currentDaySchedule === 'Not Available Today';
      }
    }
  };
</script>
